import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13.836 5.237V5.2l-3.92-3.92h-5.09a2.678 2.678 0 0 0-2.68 2.67v8.18a2.678 2.678 0 0 0 2.68 2.67h6.35a2.678 2.678 0 0 0 2.68-2.67V5.237Zm-1.48 6.89a1.18 1.18 0 0 1-1.18 1.17h-6.35a1.18 1.18 0 0 1-1.18-1.17v-8.18a1.18 1.18 0 0 1 1.18-1.17h4.4v3.11h3.13Zm-1.13-2.68v2.37c0 .19-.1.17-.42.17h-5.77c-.26 0-.26-.14-.26-.28v-.77s1.25-1.19 1.59-1.48.54-.18.81-.01a.676.676 0 0 0 .84.02c.3-.22 1.05-.91 1.35-1.12a.7.7 0 0 1 .91.06 10.358 10.358 0 0 1 .95 1.04Zm-4.1-2.31a.75.75 0 1 1-.75-.75.749.749 0 0 1 .75.75Z';
const draw24px = 'M15,1.89H7.06A3.76,3.76,0,0,0,3.31,5.63V18.37a3.76,3.76,0,0,0,3.75,3.75H17a3.76,3.76,0,0,0,3.75-3.75V7.64Zm4.26,16.48A2.25,2.25,0,0,1,17,20.62H7.06a2.25,2.25,0,0,1-2.25-2.25V5.63A2.25,2.25,0,0,1,7.06,3.38H14V8.64h5.26Zm-8.54-7.19A1.15,1.15,0,1,1,9.52,10,1.15,1.15,0,0,1,10.67,11.18Zm-3.61,7V17S9,15.18,9.49,14.73s.84-.27,1.25,0a1,1,0,0,0,1.29,0c.45-.34,1.6-1.4,2.06-1.71a1.06,1.06,0,0,1,1.38.09,14.57,14.57,0,0,1,1.47,1.59v3.62c0,.29-.16.27-.65.27H7.46C7.06,18.61,7.06,18.39,7.06,18.17Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const DocumentPictureIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'documentPicture'));
DocumentPictureIcon.displayName = 'DocumentPictureIcon';
DocumentPictureIcon.propTypes = Icon.propTypes;
DocumentPictureIcon.renderIcon = props => /*#__PURE__*/React.createElement(DocumentPictureIcon, props);
export default DocumentPictureIcon;
//# sourceMappingURL=DocumentPictureIcon.js.map